// utils/trackingPixels/dedupe.ts - utils/trackingPixels.ts split (sub-module dedupe)


import type {AnalyticsEventType} from './types.js';


export function getSessionId(): string {
    const key = 'analytics_session_id';
    let sessionId = localStorage.getItem(key);
    if (!sessionId) {
        sessionId = `sess_${Date.now()}_${Math.random().toString(36).substring(7)}`;
        localStorage.setItem(key, sessionId);
    }
    return sessionId;
}



const ANALYTICS_DEDUPE_PREFIX = 'analytics_event_dedupe:';


const ANALYTICS_DEDUPE_TTL = 1000 * 60 * 5;



export function isDuplicateEvent(eventType: AnalyticsEventType, data: { formId?: string; productId?: string; orderId?: string; brandId?: string; }): boolean {
    try {
        if (typeof window === 'undefined') return false;
        const dedupeKeyTarget = data.orderId || data.formId || data.productId || data.brandId || 'global';
        const dedupeKey = `${ANALYTICS_DEDUPE_PREFIX}${eventType}:${dedupeKeyTarget}`;
        const existing = sessionStorage.getItem(dedupeKey);
        if (existing) {
            const ts = Number(existing);
            if (!Number.isNaN(ts) && Date.now() - ts < ANALYTICS_DEDUPE_TTL) return true;
        }
        sessionStorage.setItem(dedupeKey, Date.now().toString());
    } catch (err) { console.warn('[Analytics] Gagal cek duplikasi event:', err); }
    return false;
}



export function getUserIdentifier(customerPhone?: string, customerEmail?: string): string | null {
    return customerPhone || customerEmail || null;
}
